/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type NoDriverAlertCardAlertFragment = {
  __typename: 'VehicleSurveillanceNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    label: number | null
    licensePlate: string | null
    inService: boolean | null
    isSelfDriving: boolean
    hardwareConfiguration: {
      __typename?: 'HardwareConfiguration'
      tablet: { __typename?: 'Tablet'; phoneNumber: string | null } | null
    } | null
    fleet: { __typename?: 'Fleet'; id: string } | null
    lastVehicleInteraction: {
      __typename?: 'VehicleInteraction'
      type: Types.VehicleInteractionType
    } | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export const NoDriverAlertCardAlertFragmentDoc = gql`
    fragment NoDriverAlertCardAlert on VehicleSurveillanceNotification {
  id
  status
  vehicle {
    id
    hardwareConfiguration {
      tablet {
        phoneNumber
      }
    }
    ...VehicleInteractionButton
    ...VehicleIconLinkVehicle
    ...BaseAlertCardVehicle
  }
  ...BaseAlertCardTask
}
    `
